<template>
    <section v-if="document" class="container docs-layout gap-4">
        <CmsDocument :document class="md:order-2">
            <DocsManufacturers v-if="showManufacturerNames" />
            <DocsDistributors v-else-if="showDistributorNames" />
            <DocsCompanyChangeLog v-else-if="showCompanyChangeLog" />
            <DocsRegions v-else-if="showRegionsList" />
            <DocsDssSample v-else-if="showDssSample && dssSampleDocId" :doc-id="dssSampleDocId" />
        </CmsDocument>
        <CmsNavigation :navigation :root class="md:order-1">
            <h3>
                <NuxtLinkLocale to="/docs">{{ translateMe("TrustedParts.com Documentation") }}</NuxtLinkLocale>
            </h3>
            <CmsSearch search-type="docs" :root :title="$t('StaticSiteStrings.docs_placeholder')" />
        </CmsNavigation>
        <CmsHeadings class="md:order-3" :document />
    </section>
</template>
<script setup lang="ts">
const route = useRoute();
const { locale } = useI18n();
const localePath = useLocalePath();

const root = localePath("/docs/");
const documentPath = getCMSDocumentPath("docs", locale.value, route.params.path);
const navigationPath = getCMSDocumentPath("docs", locale.value, "navigation.json");

const [{ data: document, error: docError }, { data: navigation }] = await Promise.all([
    useFetch<CMSDocument>(documentPath),
    useFetch<CMSNavItem[]>(navigationPath),
]);

if (docError.value) {
    throw showError(docError.value);
}
const { title, description } = document.value ?? {};
useSeoMeta({ title, ogTitle: title, description, ogDescription: description });

const pagePath = Array.isArray(route.params.path)
    ? route.params.path.filter((part) => !!part).join("/")
    : route.params.path;

const showManufacturerNames = computed(() => pagePath === "api/manufacturers-list");
const showDistributorNames = computed(() => pagePath === "api/distributors-list");
const showCompanyChangeLog = computed(() => pagePath === "api/company-change-log");
const showRegionsList = computed(() => pagePath === "participating-distributors/global-functionality");
const showDssSample = computed(() => pagePath?.startsWith("distributor-stock-search/sample-"));
const dssSampleDocId = computed(() => pagePath?.replace("distributor-stock-search/", ""));
</script>
<style scoped>
.docs-layout {
    display: grid;

    @media (width >= 48rem) {
        grid-template-columns: calc(var(--spacing) * 64) minmax(0, 1fr);
    }

    @media (width >= 80rem) {
        grid-template-columns: calc(var(--spacing) * 80) minmax(0, 1fr) min-content;
    }
}
</style>
